export default __webpack_public_path__ + "static/media/partner-locations-template.0c582659.csv";